export enum NPSReplacementType {
  ReplacementFor = 'ReplacementFor',
  ReplacedBy = 'ReplacedBy',
  CanNotBeReplaced = 'CanNotBeReplaced',
}
